export default {
    leaveQuota: 'Leave Quota',
    fullTimeLeave: 'Full-Time Leave',
    personalLeave: 'Personal Leave',
    sickLeave: 'Sick Leave',
    annualResetDate: 'Annual Reset Date',
    saveChanges: 'Save Changes',
    probation: 'Probation',
    probationLeave: 'Probation Leave',
    congratulation: 'Congratulation',
    leaveQuotaIsUpdated: 'Leave Quota is updated'
}
